module.exports = __webpack_public_path__ + "assets/img/footer_logo_9.be2621ab.png";